package com.exura.pages.planCreator.components.seriesViews.inputs

import androidx.compose.runtime.*
import com.exura.ui.*
import com.exura.ui.modifiers.ShadeBorder
import com.exura.ui.modifiers.insetHoverableItemStyle
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.readOnly
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Input

@Composable
fun PlanCreatorTextInput(
    value: String,
    onValueChange: (String) -> Unit,
    mode: PlanCreatorInputMode,
    placeholder: String = "",
    modifier: Modifier = Modifier,
    textStyle: String = TextStyles.normal16,
    textHeight: CSSLengthNumericValue = 16.px,
    shadeColor: ExuraRgba? = null,
) {
    val inputHeight = textHeight + 4.px + 2 * 4.px
    var isSelected by remember { mutableStateOf(false) }
    var isFocused by remember { mutableStateOf(false) }

    val isInteractive = mode == PlanCreatorInputMode.EDIT
    val showPlaceholder = value.isEmpty() && !isFocused

    val accentColor = shadeColor ?: ExuraColors.BLUE

    Box(
        modifier = Modifier
            .insetHoverableItemStyle(
                isSelected = isSelected && isInteractive,
                shadeColor = accentColor.copy(alpha = 0.1),
                shadeSize = 8.px,
                shadeBorders = listOf(ShadeBorder.TOP, ShadeBorder.LEFT),
//                backgroundColor = if (!isInteractive) ExuraColors.WHITE else ExuraColors.LIGHT_GRAY.copy(alpha = 0.1),
                hoverColor = if (!isInteractive) ExuraColors.TRANSPARENT else accentColor.copy(alpha = 0.10),
                selectedColor = accentColor.copy(alpha = 0.05),
                cursor = if (isInteractive) Cursor.Text else Cursor.Default,
                onClick = if (isInteractive) {
                    { isSelected = true }
                } else null,
                isHoverable = isInteractive
            )
            .padding(4.px)
            .height(inputHeight)
            .borderRadius(4.px)
            .then(modifier),
        contentAlignment = Alignment.CenterStart
    ) {
        // Always render input for consistent behavior, but make it readonly in VIEW mode
        Input(
            type = InputType.Text,
            attrs = Modifier
                .fillMaxSize()
                .backgroundColor(Colors.Transparent)
                .border(width = Dimens.spacingNone)
                .outline(
                    width = Dimens.spacingNone,
                    style = LineStyle.None,
                    color = Colors.Transparent
                )
                .padding(leftRight = 12.px, topBottom = 8.px)
                .classNames(textStyle)
                .color(if (showPlaceholder) ExuraColors.ARSENIC2 else ExuraColors.ARSENIC)
                .transition(
                    Transition.of(
                        property = HtmlProperties.ALL,
                        duration = 0.2.s,
                        timingFunction = AnimationTimingFunction.EaseInOut
                    )
                )
                .toAttrs {
                    value(if (showPlaceholder) placeholder else value)
                    if (isInteractive) {
                        onInput {
                            if (!showPlaceholder) {
                                onValueChange(it.value)
                            }
                        }
                        onFocus {
                            isFocused = true
                            isSelected = true
                        }
                        onBlur {
                            isFocused = false
                            isSelected = false
                        }
                    } else {
                        readOnly()
                    }
                }
        )
    }
}
